/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { ShowMessageProps } from "./interfaces";
import { Modal } from "../../atoms/Modal";
import { ModalSizeType } from "../../atoms/Modal/interface";
import { Spin } from "antd";
import { CustomButton } from "../../atoms/CustomButton";
import { useIsMobile } from "../../hooks/useIsMobile";
import { showMessageStyle } from "./styles";

export const ShowMessage: React.FunctionComponent<ShowMessageProps> = (
  props
) => {
  const {
    visible,
    loading,
    heading,
    description,
    bodyImageFileName,
    footerButtons,
    onCloseIconClick,
  } = props;
  const isMobileView = useIsMobile();

  const loadingOrinfoComponent = React.useCallback(() => {
    if (loading) {
      return (
        <div>
          <h5>{heading}</h5>
          <Spin size="large" />
          <div
            className={`my-1 text-description mt-2  ${loading ? "" : " mb-4"}`}
          >
            {description}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <h5 className={`  ${isMobileView ? "mt-5 mb-3" : "mt-4 mb-3"}`}>
            {heading}
          </h5>
          {bodyImageFileName && (
            <img
              src={require(`../../assets/${bodyImageFileName}`)}
              className="my-1"
              alt=""
            />
          )}
          <div className="my-1 text-description">{description}</div>
        </div>
      );
    }
  }, [loading, bodyImageFileName, isMobileView, description, heading]);

  const renderButtons = React.useCallback(() => {
    return footerButtons?.map((item, key) => {
      return (
        <CustomButton
          key={key}
          color={item.color}
          type={item.type}
          onClick={item.onClick}
          disabled={loading}
        >
          {item.text}
        </CustomButton>
      );
    });
  }, [footerButtons, loading]);

  return (
    <span css={showMessageStyle(loading)}>
      {visible && (
        <Modal
          modalSize={isMobileView ? ModalSizeType.LARGE : ModalSizeType.MEDIUM}
          closeModal={onCloseIconClick ? onCloseIconClick : () => console.log()}
          className="responsive-button-font"
          showCloseIcon={footerButtons ? true : false}
        >
          <div className="submitted-message">
            {loadingOrinfoComponent()}
            {!!footerButtons?.length && (
              <div className="style-footer-buttons mt-3">{renderButtons()}</div>
            )}
          </div>
        </Modal>
      )}
    </span>
  );
};
